// extracted by mini-css-extract-plugin
export default {"root":"NxwHJu","icon":"_YxFKO","ltr":"JqpQA7","withCount":"OiGM_t","badge":"IkBCOP","rtl":"veGHay"};